<template>
  <div>
    <sc-text tag="h1" v-if="fields && fields.heading" :field="fields.heading" />
    <sc-text tag="h2" v-if="fields && fields.subheading" :field="fields.subheading" />
  </div>
</template>

<script>
import { Text } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-PageTitle',
  components: {
    ScText: Text
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
